import EmptyCards from '@library/assets/images/empty-cards.svg';
import { cn } from '@library/component-utils/cn';

export interface NoResultsProps {
  className?: string;
  classNameInner?: string;
  dataTestId?: string;
  label?: string;
  title?: string;
}

export const NoResults = ({
  className = '',
  classNameInner = '',
  dataTestId = 'NoGameResults',
  label = 'Use the search bar to search for user ID or email address',
  title = 'No Results'
}: NoResultsProps) => (
  <div
    className={cn(
      'bg-soFresh-120 flex flex-row items-center rounded-lg py-[1.875rem] pl-8 text-white',
      className || 'm-8'
    )}
    data-testid={dataTestId}
  >
    <img src={EmptyCards} alt="draggable" className="grid w-fit" />
    <div
      className={cn(
        'bg-soFresh-120 flex flex-col gap-y-1 rounded-lg pb-2 text-white',
        classNameInner
      )}
    >
      <span className="ml-8 text-xl font-medium">{title}</span>
      <span className="ml-8 text-sm font-normal">{label}</span>
    </div>
  </div>
);
